var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadDocument = function SvgUploadDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 105,
    viewBox: "0 0 84 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 94.5V10.5H56.7656L73.1719 26.9062V94.5H10.8281Z",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.25,
    cy: 83.75,
    r: 18.75,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5542 91.0301C56.0988 91.0301 55.7091 90.868 55.3848 90.5438C55.0606 90.2195 54.8984 89.8297 54.8984 89.3744V85.8974H56.5542V89.3744H67.6476V85.8974H69.2826V89.3744C69.2826 89.8297 69.1205 90.2195 68.7962 90.5438C68.472 90.868 68.0891 91.0301 67.6476 91.0301H56.5542ZM61.273 87.0564V79.5642L58.8722 81.9857L57.6925 80.806L62.1009 76.3976L66.5093 80.806L65.3296 81.9857L62.9287 79.5642V87.0564H61.273Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7656 26.9062H73.1719L56.7656 10.5V26.9062Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
};
export default SvgUploadDocument;